<template>
  <router-link class="back-button" :to="to"> <v-icon>arrow_back</v-icon>{{ $t('back') }} </router-link>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    to: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.back-button {
  font-size: $font-size-sm;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;

  .v-icon {
    color: var(--brand-primary);
    margin-right: $space-2;
  }
}
</style>
